
<template>

<el-tabs v-model="activeName" type="card">
    <el-tab-pane label="banner管理" name="first" :lazy="true">
        <advertisement></advertisement>
    </el-tab-pane>
    <el-tab-pane label="活动管理" name="second">
        <plus-activity></plus-activity>
    </el-tab-pane>
    <el-tab-pane label="配置" name="three">
        <plus-configure></plus-configure>
    </el-tab-pane>
</el-tabs>

</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import plusActivity from './plusActivity'
import advertisement from './advertisement'
import plusConfigure from './children/plusConfigure'
export default {
  name: 'tab-index',
  extends: BasicPager,
  components: {
    plusActivity,
    advertisement,
    plusConfigure
  },
  data () {
    return {
      activeName: 'first'
    }
  }
}

</script>
